import { DocumentsListParams } from '../../types/Document';
import { getEnv } from '../../utils/env';

const runtimeEnvApiUrl =
  typeof window !== 'undefined'
    ? {
        prod: import.meta.env.VITE_PROD_API_URL,
        preprod: import.meta.env.VITE_PREPROD_API_URL,
        staging:
          import.meta.env.VITE_STAGING_V2_API_URL ||
          import.meta.env.VITE_STAGING_API_URL,
        dev: import.meta.env.VITE_DEV_API_URL,
        local: import.meta.env.VITE_LOCAL_API_URL,
      }[getEnv()]
    : undefined;

const prefixer = import.meta.env.VITE_API_URL || runtimeEnvApiUrl || '/api';

export const AuthUrls = {
  PASSWORD_LOGIN: `${prefixer}/auth/login`,
  RESET_PASSWORD_INIT: `${prefixer}/auth/forgot-password`,
  RESET_PASSWORD: `${prefixer}/auth/reset-password`,
  CREATE_PASSWORD: `${prefixer}/auth/create-password`,
  REFRESH_TOKEN: `${prefixer}/auth/refresh-token`,
  IMPERSONATE: `${prefixer}/auth/impersonate`,
};

export const ExternalUrls = {
  GET_NEWS_RSS: 'https://www.hellio.com/actualites/rss.xml',
  GET_TRANSPORTS_NEWS_RSS:
    'https://www.hellio.com/actualites/tag/transport/rss.xml',
};

export const UserUrls = {
  GET_CONNECTED_INFO: `${prefixer}/user/me`,
  GET_ACCOUNT_INFO: `${prefixer}/user/infos`,
  GET_ACCOUNT_OWNER_INFO: `${prefixer}/user/me/owner`,
  RESEND_ACCOUNT_EMAIL: `${prefixer}/user/resend-activation-email`,
};

export const NotificationsUrls = {
  GET: `${prefixer}/notifications`,
  MARK_READ: `${prefixer}/notifications/read`,
};

export const MetricsUrls = {
  GET: (path: string = '') => `${prefixer}/metrics/${path}`,
  HOME: `${prefixer}/metrics/home`,
};

export const PickListUrls = {
  GET: (objectType: string, fieldName: string) =>
    `${prefixer}/${objectType}/picklist/${fieldName}`,
};

export const DossiersUrls = {
  ADD: `${prefixer}/dossiers`,
  EXPORT: `${prefixer}/dossiers/export`,
  LIST: `${prefixer}/dossiers`,
  GET_REFERENTS_COMMERCIAUX: `${prefixer}/dossiers/referents-commerciaux`,
  GET: (dossierId: string) => `${prefixer}/dossiers/${dossierId}`,
  OPERATIONS: (dossierId: string, offset: number = 0, limit: number = 10) =>
    `${prefixer}/dossiers/${dossierId}/operations?offset=${offset}&limit=${limit}`,
  OPERATIONS_WITH_PARAMS: (dossierId: string) =>
    `${prefixer}/dossiers/${dossierId}/operations`,
  OPERATION: (dossierId: string, operationId: string) =>
    `${prefixer}/dossiers/${dossierId}/operations/${operationId}`,
  ATTACHMENTS: (dossierId: string) =>
    `${prefixer}/dossiers/${dossierId}/attachments/multiple`,
  SIRETS: `${prefixer}/dossiers/sirets`,
  NEW_FORM: `${prefixer}/dossiers/concession`,
  NEW_FORM_PARTICULIER: `${prefixer}/dossiers/concession/particulier`,
  GENERATION_AH(operationId: string) {
    return `${prefixer}/dossiers/concession/generate-ah/${operationId}`;
  },
  GENERATION_AH_SIGNATAIRES(dossierId: string, operationId: string) {
    return `${prefixer}/dossiers/${dossierId}/operations/${operationId}/ah`;
  },
  CALCULATE_PRIME: `${prefixer}/dossiers/concession/calcul`,
  CALCULATE_PRIME_PARTICULIER: `${prefixer}/dossiers/concession/particulier/calcul`,
  GET_DEPARTMENT_CODE: (postalCode: string) =>
    `${prefixer}/dossiers/department-code/${postalCode}`,
  GET_COMPANIES: `${prefixer}/dossiers/companies`,
};

export const AttachmentsUrls = {
  DOWNLOAD_ATTACHMENT: (token: string) =>
    `${prefixer}/attachments/download/${token}`,
  GET_DOWNLOAD: (attachmentId: string) =>
    `${prefixer}/attachments/get-download/${attachmentId}`,
};

export const DocumentsUrls = {
  LIST: (params: DocumentsListParams) => {
    const searchParam = params.search
      ? `&search=${encodeURIComponent(params.search)}`
      : '';
    const categoryParam = params.category
      ? `&category=${encodeURIComponent(params.category)}`
      : '';
    return `${prefixer}/documents?page=${params.page}&per_page=${params.per_page}${searchParam}${categoryParam}`;
  },
  VIEW: (id: string) => `${prefixer}/documents/${id}`,
  THUMBNAIL: (id: string) => `${prefixer}/documents/thumbnail/${id}`,
  REGULATORY_CALENDAR: `${prefixer}/documents/calendrier-reglementaire`,
};

export const GlossaireUrls = {
  LIST: `${prefixer}/documents/glossaire`,
};

export const SimulateurUrls = {
  FOSTS: (secteur: string) => `${prefixer}/simulateur/fosts/${secteur}`,
  CRITERES_ELIGIBILITE: (fost: string) =>
    `${prefixer}/simulateur/criteres-eligibilite/${fost}`,
  CHAMPS_REQUIS: (fost: string) =>
    `${prefixer}/simulateur/champs-requis/${fost}`,
  RUN: `${prefixer}/simulateur`,
  PRIMES_CONCESSIONNAIRES: `${prefixer}/simulateur/primes-concessionnaire`,
};

export const SimulationsUrls = {
  SAVE: `${prefixer}/simulations`,
  LIST: `${prefixer}/simulations`,
  EXPORT: `${prefixer}/simulations/export`,
  VIEW(id: string) {
    return `${prefixer}/simulations/${id}`;
  },
};

export const DataGouvUrls = {
  ADRESSE_SEARCH: 'https://api-adresse.data.gouv.fr/search/',
  DEPARTEMENTS: 'https://geo.api.gouv.fr/departements',
};
